import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import MFWrapper from '../common/MFWrapper';

const BasenameProps = {
  basename: PropTypes.string.isRequired,
};

const shopEnhancer = compose(
  withProps(() => ({
    basename: '/memberships',
  })),
);

const brandEnhancer = compose(
  withProps(() => ({
    basename: '/brand/memberships',
  })),
);

const ShopMemberships = React.lazy(() => import('memberships/Shop'));

const WrappedShopMemberships = props => (
  <MFWrapper>
    <ShopMemberships basename={props.basename} />
  </MFWrapper>
);

WrappedShopMemberships.propTypes = BasenameProps;

const ExternalShopMemberships = shopEnhancer(WrappedShopMemberships);

const BrandMemberships = React.lazy(() => import('memberships/Brand'));

const WrappedBrandMemberships = props => (
  <MFWrapper>
    <BrandMemberships basename={props.basename} />
  </MFWrapper>
);

WrappedBrandMemberships.propTypes = BasenameProps;

const ExternalBrandMemberships = brandEnhancer(WrappedBrandMemberships);

const MembershipHeader = React.lazy(() => import('memberships/Header'));

const WrappedMembershipHeader = props => (
  <MFWrapper>
    <MembershipHeader basename={props.basename} />
  </MFWrapper>
);

WrappedMembershipHeader.propTypes = BasenameProps;

const ExternalBrandMembershipsHeader = brandEnhancer(WrappedMembershipHeader);
const ExternalShopMembershipsHeader = shopEnhancer(WrappedMembershipHeader);

export {
  ExternalBrandMemberships,
  ExternalShopMemberships,
  ExternalBrandMembershipsHeader,
  ExternalShopMembershipsHeader,
};
